import { IconPropsType } from '..';

export const HorizontalMoreIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="general=default, betting=default, statuses=default, arrows=default, toggleables=default, signs=default, menus=more-alt, casino=default">
      <path
        id="Vector"
        d="M14.0001 10.0001C14.0001 10.5305 14.2108 11.0392 14.5858 11.4143C14.9609 11.7893 15.4696 12.0001 16.0001 12.0001C16.5305 12.0001 17.0392 11.7893 17.4143 11.4143C17.7893 11.0392 18.0001 10.5305 18.0001 10.0001C18.0001 9.46963 17.7893 8.96092 17.4143 8.58585C17.0392 8.21077 16.5305 8.00006 16.0001 8.00006C15.4696 8.00006 14.9609 8.21077 14.5858 8.58585C14.2108 8.96092 14.0001 9.46963 14.0001 10.0001ZM2.00006 10.0001C2.00006 10.5305 2.21077 11.0392 2.58585 11.4143C2.96092 11.7893 3.46963 12.0001 4.00006 12.0001C4.53049 12.0001 5.0392 11.7893 5.41427 11.4143C5.78935 11.0392 6.00006 10.5305 6.00006 10.0001C6.00006 9.46963 5.78935 8.96092 5.41427 8.58585C5.0392 8.21077 4.53049 8.00006 4.00006 8.00006C3.46963 8.00006 2.96092 8.21077 2.58585 8.58585C2.21077 8.96092 2.00006 9.46963 2.00006 10.0001ZM8.00006 10.0001C8.00006 10.5305 8.21077 11.0392 8.58585 11.4143C8.96092 11.7893 9.46963 12.0001 10.0001 12.0001C10.5305 12.0001 11.0392 11.7893 11.4143 11.4143C11.7893 11.0392 12.0001 10.5305 12.0001 10.0001C12.0001 9.46963 11.7893 8.96092 11.4143 8.58585C11.0392 8.21077 10.5305 8.00006 10.0001 8.00006C9.46963 8.00006 8.96092 8.21077 8.58585 8.58585C8.21077 8.96092 8.00006 9.46963 8.00006 10.0001Z"
        fill="#8388A3"
      />
    </g>
  </svg>
);
